import React, { Suspense } from 'react';
import { Text, Billboard } from '@react-three/drei';
import Bin from "./Bin";

 const Rack = ({
  rack,
  onBinClick,
  selectedBin,
  setLegendData,
  selectedEntity,
  color,
  opacity,
  setBinCounts
}) => {
 const { children = [], width, height, length, xco, yco, zco, id, en_name, entity_name } = rack;

  // Collect all bins in this rack (children assumed to be bins)
  const allBins = children.filter(child => child.en_name === "Bin");
  const labelPosition = [xco, yco + height + 0.3, zco];

  return (
    <>
      <Suspense fallback={null}>
        <Billboard position={labelPosition}>
          <Text
            fontSize={4}
            fontWeight={800}
            color="black"
            anchorX="center"
            anchorY="middle"
            billboard
          >
            {`${en_name}(${entity_name})`}
          </Text>
        </Billboard>
      </Suspense>

      {children.map(entity => (
        <Bin
          key={entity.id}
          bin={entity}
          onBinClick={onBinClick}
          selectedBin={selectedBin}
          setLegendData={setLegendData}
          selectedEntity={selectedEntity}
          color={color}
          opacity={opacity}
          parentZoneId={rack.parent_entity_id}
          allBins={allBins}  // Pass the full bins array for column tooltip logic
        />
      ))}
    </>
  );
};

export default Rack;
